export enum ConceptCategoryEnum {
  Allergy = 1,
  Dme = 2,
  MedicalHistory = 3,
  FallRisk = 4
}

export const ConceptCategoryOptions = [
{ id: 1, label: 'Allergy' },
{ id: 2, label: 'Dme' },
{ id: 3, label: 'Medical History' },
{ id: 4, label: 'Fall Risk' }
];
